import { render, staticRenderFns } from "./AdminStatsFrequencies.vue?vue&type=template&id=72016e46&"
import script from "./AdminStatsFrequencies.vue?vue&type=script&lang=js&"
export * from "./AdminStatsFrequencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports